import React, { FC } from 'react';
import { Image } from '@src/components/Image';
import { Button } from '@src/components/Button';
import { EmptyStateProps } from './props';
import './styles.scss';

export const EmptyState: FC<EmptyStateProps> = ({ title, text, imageUrl, buttonLabel, buttonProps }) => {
  return (
    <div className="ta-empty-state">
      <Image className="ta-empty-state__image" src={imageUrl} />
      <h3 className="ta-empty-state__title">{title}</h3>
      <p className="ta-empty-state__text">{text}</p>
      {buttonLabel ? (
        <Button className="ta-empty-state__button" {...buttonProps}>
          {buttonLabel}
        </Button>
      ) : null}
    </div>
  );
};
